import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Trans, useTranslation } from "react-i18next";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import { sprintf } from "sprintf-js";
import makeStyles from "@mui/styles/makeStyles";
import { checkFilter } from "../../Mobile/hooks/useFilteredTemplateList";
import useDialogBackButton from "@/react/hooks/useDialogBackButton";

const useStyles = makeStyles((theme) => ({
  paper: {
    minWidth: "70vw",
    "& h3": {
      marginBottom: "0.3em",
      textAlign: "center",
      textTransform: "uppercase",
    },
  },
  filtersContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  formControl: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
}));

const checkOptionFilter = (template, filter, option) => {
  return filter.filterFunction(template, option.value);
};

export default ({
  onClose,
  onOpen,
  filters,
  toggleFilterOption,
  templates,
  filteredTemplates,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  // Hardware/browser back closes the dialog instead of navigating away.
  useDialogBackButton(true, onClose);

  return (
    <Dialog open={true} classes={{ paper: classes.paper }} onClose={onClose}>
      <DialogTitle>
        <Trans>Filter selection</Trans>
      </DialogTitle>
      <DialogContent>
        {filters.map((filter) => {
          const otherFiltersTemplates = templates.filter((template) => {
            for (const theFilter of filters) {
              if (theFilter.type === filter.type) {
                continue;
              }
              if (!checkFilter(template, theFilter)) {
                return false;
              }
            }
            return true;
          });

          return (
            <>
              <h3>{filter.title}</h3>
              <div className={classes.filtersContainer}>
                {filter.options.map((option) => {
                  return (
                    <FormControlLabel
                      key={filter.type + "_" + option.value}
                      classes={{ root: classes.formControl }}
                      control={
                        <Checkbox
                          edge="start"
                          checked={option.checked}
                          tabIndex={-1}
                          disableRipple
                          color="primary"
                          size="small"
                          onClick={() =>
                            toggleFilterOption(filter.type, option.value)
                          }
                        />
                      }
                      label={option.name}
                    />
                  );

                  {
                    /*<ListItemText id={labelId} primary={`${option.name} (${numTemplates})`}
                                         className={numTemplates == 0 ? classes.optionNoHits : ''}
                           />*/
                  }
                })}
              </div>
            </>
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={onClose}
        >
          {sprintf(t("Show %d templates"), filteredTemplates.length)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
